<template>
  <div class="projects-archive">
    <app-view-layout
      header="Archiwalne projekty"
      fluid
    >
      <template #toolbarMenu>
        <ProjectsListToolbarMenu
          archive
          @search="fetchProjects"
        />
      </template>

      <template #content>
        <ProjectsListSearchbar
          archive
          @search="fetchProjects"
        />

        <v-fade-transition mode="out-in">
          <div
            v-if="projectsList.length"
            key="ProjectList"
          >
            <ProjectsList
              v-if="viewMode === 'list'"
              @fetch="fetchProjects"
            />
            <ProjectsTable
              v-else
              @fetch="fetchProjects"
            />
            <AppPagination @change="fetchProjects" />
          </div>
          <AppEmptyList
            v-else
            key="emptyList"
            header="Nie znaleziono żadnych projektów w archiwum."
            text="Nie znaleziono żadnych projektów w archiwum. <br>
              Zmień w filtrach sposób wyszukiwania."
            class="projects-archive__empty"
          />
        </v-fade-transition>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import ProjectsListToolbarMenu from '@/components/Projects/ProjectsListToolbarMenu.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import ProjectsListSearchbar from '@/components/Projects/ProjectsListSearchbar.vue';
import ProjectsList from '@/components/Projects/ProjectsList.vue';
import ProjectsTable from '@/components/Projects/ProjectsTable.vue';

export default {
  components: {
    AppViewLayout,
    ProjectCard,
    ProjectsListToolbarMenu,
    ProjectsListSearchbar,
    AppPagination,
    AppEmptyList,
    ProjectsList,
    ProjectsTable,
  },

  computed: {
    ...mapState('projects', ['projectsList', 'viewMode']),
    ...mapState('pagination', ['pagination']),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== 'archive-project-single') {
        vm.resetProjects();
      }
      vm.$store.dispatch(
        'filters/setFilters',
        { statuses: ['Zaakceptowany i zarchiwizowany'] },
        { root: true }
      );
      vm.fetchProjects();
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== 'archive-project-single') this.resetProjects();
    next();
  },

  methods: {
    ...mapActions('dialog', ['showDialog']),
    ...mapActions('projects', ['fetchProjects', 'resetProjects']),
  },
};
</script>

<style lang="scss" scoped>
.projects-archive {
  &__empty {
    min-height: calc(100vh - 220px);
  }
}
</style>
